export default __webpack_public_path__ + "static/media/8.66c8cb9e.png";